import {
  WfHeader,
  WfIconMiscZonesRegular,
  WfMenuList,
  WfMenuListItem,
} from "@WahooFitness/redesignr";
import { t } from "@lingui/macro";
import { ReactRouterLinkWrapper } from "../../MenuList/ReactRouterLinkWrapper";
import {
  FitnessProfileResponseType,
  WahooWorkoutTypeFamily,
} from "@WahooFitness/cloud-client-types";
import AthleteProfilePreviewCard from "../AthleteProfilePreviewCard";
import { Box } from "@mui/material";
import { useMemo } from "react";

interface AthleteProfileSectionProps {
  showMissingFitnessProfileBadge: boolean;
  cyclingFitnessProfile?: FitnessProfileResponseType;
  runningFitnessProfile?: FitnessProfileResponseType;
  selectedFitnessProfiles?: WahooWorkoutTypeFamily[];
}
function AthleteProfileSection({
  showMissingFitnessProfileBadge,
  cyclingFitnessProfile,
  runningFitnessProfile,
  selectedFitnessProfiles,
}: AthleteProfileSectionProps) {
  const fitnessProfileCards = useMemo(() => {
    const profiles = selectedFitnessProfiles ?? [
      WahooWorkoutTypeFamily.Cycling,
      WahooWorkoutTypeFamily.Running,
    ];

    return profiles
      .filter(
        (profile) =>
          profile === WahooWorkoutTypeFamily.Cycling || profile === WahooWorkoutTypeFamily.Running
      )
      .map((profile) => {
        if (
          profile !== WahooWorkoutTypeFamily.Cycling &&
          profile !== WahooWorkoutTypeFamily.Running
        ) {
          return null;
        }
        const fitnessProfile =
          profile === WahooWorkoutTypeFamily.Cycling
            ? cyclingFitnessProfile
            : runningFitnessProfile;
        return (
          <AthleteProfilePreviewCard
            key={profile}
            workoutFamily={profile}
            fitnessProfile={fitnessProfile}
          />
        );
      });
  }, [selectedFitnessProfiles, cyclingFitnessProfile, runningFitnessProfile]);

  return (
    <>
      <WfHeader
        title={t`Athlete Profile`}
        hierarchy="H1"
        data-testid="athleteProfileHeader"
        showBadge={showMissingFitnessProfileBadge}
      />
      <Box display="flex" gap={1} flexDirection="row" width="100%" px={2}>
        {fitnessProfileCards}
      </Box>
      <WfMenuList>
        <WfMenuListItem
          id="zones"
          content={t`Zones`}
          variant="internalLink"
          href="/zones"
          linkComponent={ReactRouterLinkWrapper}
          startIcon={<WfIconMiscZonesRegular />}
          data-testid="settings.zones"
        />
      </WfMenuList>
    </>
  );
}

export default AthleteProfileSection;
